import { SpeakingClassLevel } from "../gql/graphql.ts";
import { SelectOption } from "@normasteaching/norma-ui";

export function getAllSpeakingClassLevelOptions(): SelectOption<SpeakingClassLevel>[] {
  return Object.values(SpeakingClassLevel).map((v) => ({
    name: v,
    id: v,
  }));
}
